import Mark from 'mark.js';
import { useEffect } from 'react';

import { useMemoizedBundle } from './useMemoizedBundle';

export const useHighlightSearch = (
  textOrTextList: Parameters<Mark['mark']>[0],
  selector: ConstructorParameters<typeof Mark>[0],
  {
    markOptions = {},
    otherDeps = [],
  }: {
    markOptions?: Parameters<Mark['mark']>[1];
    otherDeps?: unknown[];
  } = {},
) => {
  const memoizedOptions = useMemoizedBundle(markOptions);

  useEffect(() => {
    const markInstance = new Mark(selector);

    markInstance.mark(textOrTextList, memoizedOptions);

    return () => markInstance.unmark();
  }, [
    textOrTextList,
    selector,
    memoizedOptions,

    ...otherDeps,
  ]);
};
